import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.timedoutmodal.title',
    defaultMessage: 'Timedout Error',
  },
  description: {
    id: 'components.timedoutmodal.description',
    defaultMessage: 'Your session has expired, please refill the eligibility form.',
  },
});
